export default "__VITE_ASSET__C5_m$7o5__"